<ng-container *ngFor="let service of services_names">
	<div *ngIf="service.name !== 'Saving Plans Routing'" class="card-footer">
		<i
			*ngIf="!isCollapsed[service.name]"
			class="fas fa-plus pr-2 cursor-link"
			(click)="isCollapsed[service.name] = !isCollapsed[service.name]"
		></i>
		<i
			*ngIf="isCollapsed[service.name]"
			class="fas fa-minus pr-2 cursor-link"
			(click)="isCollapsed[service.name] = !isCollapsed[service.name]"
		></i>
		<input
			type="checkbox"
			name="list"
			id="{{ service.name }}Checkbox"
			[checked]="checkIfServiceHaveActivePerm(service.name)"
			[disabled]="true"
		/>
		<span class="pl-2">{{ service.name }}</span>
	</div>
	<div *ngIf="service.name === 'Saving Plans Routing'" class="card-footer">
		<i
			*ngIf="!isCollapsed[service.name]"
			class="fas fa-plus pr-2 cursor-link"
			(click)="isCollapsed[service.name] = !isCollapsed[service.name]"
		></i>
		<i
			*ngIf="isCollapsed[service.name]"
			class="fas fa-minus pr-2 cursor-link"
			(click)="isCollapsed[service.name] = !isCollapsed[service.name]"
		></i>
		<input
			type="checkbox"
			name="list"
			id="{{ service.name }}Checkbox"
			[checked]="checkIfServiceHaveActivePerm(service.name)"
			[disabled]="true"
		/>
		<span class="pl-2">{{ service.name }}</span>
	</div>
	<div class="card-body" style="background: #0033480d" [collapse]="!isCollapsed[service.name]">
		<b>Actions:</b>
		<div class="row" *ngFor="let item of services_lists[service.name]">
			<div class="col-2 text-right"></div>
			<div class="col-10" *ngIf="service.name !== 'Saving Plans Routing'">
				<b>Specify the actions allowed in {{ item }}:</b>
				<div class="cursor-link mt-2" *ngIf="services_map[service.name].AWS.Services[item].list.length > 0">
					<i
						class="fas fa-caret-down pr-1"
						(click)="isCollapsed[service.name + item + 'list'] = !isCollapsed[service.name + item + 'list']"
					></i>
					<input
						type="checkbox"
						id="{{ service.name }}{{ item }}listCheckbox"
						name="list"
						value=""
						[checked]="checkIfActionHaveActivePerm(service.name, item, 'list')"
						[disabled]="true"
					/>
					List
					<span class="link-color"> ({{ services_map[service.name].AWS.Services[item].list.length }} selected)</span>
				</div>

				<div class="pt-2 pb-2" style="background: #f0f9ff" [collapse]="!isCollapsed[service.name + item + 'list']">
					<ul class="perm_list">
						<li
							*ngFor="let element of services_map[service.name].AWS.Services[item].list"
							id="{{ element }}"
							class="p-1"
						>
							<input
								type="checkbox"
								id="{{ element }}Checkbox"
								name="list"
								value=""
								[checked]="permissions_to_be[item].includes(element)"
								[disabled]="true"
							/>
							{{ element }}
						</li>
					</ul>
				</div>

				<div class="cursor-link" *ngIf="services_map[service.name].AWS.Services[item].read.length > 0">
					<i
						class="fas fa-caret-down pr-1"
						(click)="isCollapsed[service.name + item + 'read'] = !isCollapsed[service.name + item + 'read']"
					></i>
					<input
						type="checkbox"
						id="{{ service.name }}{{ item }}readCheckbox"
						name="read"
						value=""
						[checked]="checkIfActionHaveActivePerm(service.name, item, 'read')"
						[disabled]="true"
					/>
					Read
					<span class="link-color"> ({{ services_map[service.name].AWS.Services[item].read.length }} selected)</span>
				</div>

				<div class="pt-2 pb-2" style="background: #f0f9ff" [collapse]="!isCollapsed[service.name + item + 'read']">
					<ul class="perm_list">
						<li
							*ngFor="let element of services_map[service.name].AWS.Services[item].read"
							name="read"
							id="{{ element }}"
							class="p-1"
						>
							<input
								type="checkbox"
								id="{{ element }}Checkbox"
								name="read"
								value=""
								[checked]="permissions_to_be[item].includes(element)"
								[disabled]="true"
							/>
							{{ element }}
						</li>
					</ul>
				</div>

				<div
					*ngIf="
						services_map[service.name].AWS.Services[item].write_mandatory.length > 0 ||
						services_map[service.name].AWS.Services[item].write_opt.length > 0
					"
					class="cursor-link"
				>
					<i
						class="fas fa-caret-down pr-1"
						(click)="isCollapsed[service.name + item + 'write'] = !isCollapsed[service.name + item + 'write']"
					></i>
					<input
						type="checkbox"
						name="write"
						value=""
						id="{{ service.name }}{{ item }}writeCheckbox"
						[checked]="
							checkIfActionHaveActivePerm(service.name, item, 'write_mandatory') ||
							checkIfActionHaveActivePerm(service.name, item, 'write_opt')
						"
						[disabled]="true"
					/>
					Write
					<span class="link-color">
						({{
							services_map[service.name].AWS.Services[item].write_mandatory.length +
								services_map[service.name].AWS.Services[item].write_opt.length
						}}
						selected)</span
					>
				</div>

				<div
					*ngIf="
						services_map[service.name].AWS.Services[item].write_mandatory.length > 0 ||
						services_map[service.name].AWS.Services[item].write_opt.length > 0
					"
					class="pt-2 pb-2"
					style="background: #f0f9ff"
					[collapse]="!isCollapsed[service.name + item + 'write']"
				>
					<ul class="perm_list">
						<ng-container>
							<li
								*ngFor="let element of services_map[service.name].AWS.Services[item].write_opt"
								id="{{ element }}"
								class="p-1"
							>
								<input
									type="checkbox"
									id="{{ element }}Checkbox"
									name="write"
									value=""
									[checked]="permissions_to_be[item].includes(element)"
									[disabled]="true"
								/>
								{{ element }}
							</li>
						</ng-container>
						<li
							*ngFor="let element of services_map[service.name].AWS.Services[item].write_mandatory"
							id="{{ element }}"
							class="p-1"
						>
							<input
								type="checkbox"
								id="{{ element }}Checkbox"
								name="write"
								value=""
								[checked]="permissions_to_be[item].includes(element)"
								[disabled]="true"
							/>
							{{ element }}
						</li>
					</ul>
				</div>
			</div>

			<div class="col-10" *ngIf="service.name === 'Saving Plans Routing'">
				<b>Specify the actions allowed in {{ item }}:</b>
				<div class="cursor-link mt-2" *ngIf="services_map[service.name].AWS.Services[item].list.length > 0">
					<i
						class="fas fa-caret-down pr-1"
						(click)="isCollapsed[service.name + item + 'list'] = !isCollapsed[service.name + item + 'list']"
					></i>
					<input
						type="checkbox"
						id="{{ service.name }}{{ item }}listCheckbox"
						name="list"
						value=""
						[checked]="checkIfActionHaveActivePerm(service.name, item, 'list')"
						[disabled]="true"
					/>
					List
					<span class="link-color"> ({{ services_map[service.name].AWS.Services[item].list.length }} selected)</span>
				</div>

				<div class="pt-2 pb-2" style="background: #f0f9ff" [collapse]="!isCollapsed[service.name + item + 'list']">
					<ul class="perm_list">
						<li
							*ngFor="let element of services_map[service.name].AWS.Services[item].list"
							id="{{ element }}"
							class="p-1"
						>
							<input
								type="checkbox"
								id="{{ element }}Checkbox"
								name="list"
								value=""
								[checked]="permissions_to_be[item].includes(element)"
								[disabled]="true"
							/>
							{{ element }}
						</li>
					</ul>
				</div>

				<div class="cursor-link" *ngIf="services_map[service.name].AWS.Services[item].read.length > 0">
					<i
						class="fas fa-caret-down pr-1"
						(click)="isCollapsed[service.name + item + 'read'] = !isCollapsed[service.name + item + 'read']"
					></i>
					<input
						type="checkbox"
						id="{{ service.name }}{{ item }}readCheckbox"
						name="read"
						value=""
						[checked]="checkIfActionHaveActivePerm(service.name, item, 'read')"
						[disabled]="true"
					/>
					Read
					<span class="link-color"> ({{ services_map[service.name].AWS.Services[item].read.length }} selected)</span>
				</div>

				<div class="pt-2 pb-2" style="background: #f0f9ff" [collapse]="!isCollapsed[service.name + item + 'read']">
					<ul class="perm_list">
						<li
							*ngFor="let element of services_map[service.name].AWS.Services[item].read"
							name="read"
							id="{{ element }}"
							class="p-1"
						>
							<input
								type="checkbox"
								id="{{ element }}Checkbox"
								name="read"
								value=""
								[checked]="permissions_to_be[item].includes(element)"
								[disabled]="true"
							/>
							{{ element }}
						</li>
					</ul>
				</div>

				<div
					*ngIf="
						services_map[service.name].AWS.Services[item].write_mandatory.length > 0 ||
						services_map[service.name].AWS.Services[item].write_opt.length > 0
					"
					class="cursor-link"
				>
					<i
						class="fas fa-caret-down pr-1"
						(click)="isCollapsed[service.name + item + 'write'] = !isCollapsed[service.name + item + 'write']"
					></i>
					<input
						type="checkbox"
						name="write"
						value=""
						id="{{ service.name }}{{ item }}writeCheckbox"
						[checked]="
							checkIfActionHaveActivePerm(service.name, item, 'write_mandatory') ||
							checkIfActionHaveActivePerm(service.name, item, 'write_opt')
						"
						[disabled]="true"
					/>
					Write
					<span class="link-color">
						({{
							services_map[service.name].AWS.Services[item].write_mandatory.length +
								services_map[service.name].AWS.Services[item].write_opt.length
						}}
						selected)</span
					>
				</div>

				<div
					*ngIf="
						services_map[service.name].AWS.Services[item].write_mandatory.length > 0 ||
						services_map[service.name].AWS.Services[item].write_opt.length > 0
					"
					class="pt-2 pb-2"
					style="background: #f0f9ff"
					[collapse]="!isCollapsed[service.name + item + 'write']"
				>
					<ul class="perm_list">
						<ng-container>
							<li
								*ngFor="let element of services_map[service.name].AWS.Services[item].write_opt"
								id="{{ element }}"
								class="p-1"
							>
								<input
									type="checkbox"
									id="{{ element }}Checkbox"
									name="write"
									value=""
									[checked]="permissions_to_be[item].includes(element)"
									[disabled]="true"
								/>
								{{ element }}
							</li>
						</ng-container>
						<li
							*ngFor="let element of services_map[service.name].AWS.Services[item].write_mandatory"
							id="{{ element }}"
							class="p-1"
						>
							<input
								type="checkbox"
								id="{{ element }}Checkbox"
								name="write"
								value=""
								[checked]="permissions_to_be[item].includes(element)"
								[disabled]="true"
							/>
							{{ element }}
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</ng-container>
